import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import App from './App';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#181a20',
      paper: '#23272f',
    },
    primary: {
      main: '#3b82f6',
    },
    secondary: {
      main: '#9c27b0',
    },
    text: {
      primary: '#fff',
      secondary: '#b0b3b8',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(255, 255, 255, 0.12)',
          borderRadius: 8,
          overflow: 'hidden',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          color: '#b0b3b8',
          borderColor: 'rgba(255, 255, 255, 0.12)',
          padding: '8px 16px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            color: '#fff',
          },
          '&.Mui-selected': {
            color: '#ffffff',
            backgroundColor: '#3b82f6',
            borderColor: '#3b82f6',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#2563eb',
              borderColor: '#2563eb',
            },
          },
        },
      },
    },
  },
});

export default function ThemedApp() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}
